import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function Footer() {
  const location = useLocation();
  if (location.pathname.startsWith("/espace-client") || location.pathname.startsWith("/admin")) return null;

  return (
    <footer className="relative border-t border-white/5 bg-[#0a0a0a]" data-testid="site-footer">
      <div className="hazard-stripes h-2 w-full" />
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <img src="/assets/logo.png" alt="DCR-BATI" className="h-24 w-auto -ml-3" />
          <p className="mt-4 text-neutral-400 max-w-md leading-relaxed">
            Spécialiste du gros œuvre sur chantiers neufs. Coffrage, planchers béton, platelage de poutres et structures béton armé. Précision, sécurité et conformité.
          </p>
          <div className="mt-6 flex items-center gap-2 text-xs text-neutral-500 font-mono-tech tracking-widest uppercase">
            <span className="w-2 h-2 bg-[#ffd600]" /> RGE · Qualibat · Décennale
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="font-display uppercase tracking-widest text-xs text-neutral-500 mb-4">Navigation</div>
          <ul className="space-y-2 text-neutral-300">
            <li><Link to="/services" className="hover:text-[#ffd600]">Services</Link></li>
            <li><Link to="/realisations" className="hover:text-[#ffd600]">Réalisations</Link></li>
            <li><Link to="/a-propos" className="hover:text-[#ffd600]">À propos</Link></li>
            <li><Link to="/contact" className="hover:text-[#ffd600]">Contact</Link></li>
            <li><Link to="/devis" className="hover:text-[#ffd600]">Demander un devis</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="font-display uppercase tracking-widest text-xs text-neutral-500 mb-4">Contact</div>
          <ul className="space-y-3 text-neutral-300">
            <li className="flex items-start gap-3"><i className="fa-solid fa-location-dot text-[#ffd600] mt-1" /> 470 Clos de la Courtine, 93160 Noisy-le-Grand</li>
            <li className="flex items-start gap-3"><i className="fa-solid fa-phone text-[#ffd600] mt-1" /> 06 51 02 60 78 · 07 66 00 10 01</li>
            <li className="flex items-start gap-3"><i className="fa-solid fa-envelope text-[#ffd600] mt-1" /> contact@dcrbati.fr</li>
            <li className="flex items-start gap-3"><i className="fa-solid fa-map text-[#ffd600] mt-1" /> Intervention : toute l&apos;Île-de-France (75·77·78·91·92·93·94·95)</li>
            <li className="flex items-start gap-3"><i className="fa-solid fa-clock text-[#ffd600] mt-1" /> Lun–Ven · 7h30 – 18h00</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-neutral-500 font-mono-tech">
          <div>© {new Date().getFullYear()} DCR-BATI · Tous droits réservés</div>
          <div className="tracking-widest uppercase">Île-de-France · Gros œuvre · Béton armé</div>
        </div>
      </div>
    </footer>
  );
}
